import { Tab } from './chunk-MRQ3HZFA.js';

// src/raf.ts
var FRAME_TIME = 1e3 / 60;
var frameRatio = 1;
function getFrameRatio() {
  return frameRatio;
}
var _RafHub = class {
  constructor() {
    this.list = [];
    this.on = true;
    this._tickHandler = this._tick.bind(this);
    this._tPrev = null;
    this.fpsWatcher = { frames: 0, lastTs: performance.now() };
    Tab.add({
      start: this._onResume.bind(this),
      stop: this._onPause.bind(this)
    });
    this._raf();
  }
  _onPause() {
    this.on = false;
  }
  _onResume(delta) {
    const offset = Number.isFinite(delta) ? delta : 0;
    for (const it of this.list) it.startTime += offset;
    this.on = true;
    this._tPrev = null;
  }
  add(name, cb) {
    const item = { name, id: /* @__PURE__ */ Symbol("raf"), cb, startTime: 0 };
    this.list.push(item);
    this._sortList();
    return item.id;
  }
  remove(id) {
    const i = this.list.findIndex((it) => it.id === id);
    if (i >= 0) this.list.splice(i, 1);
  }
  _sortList() {
    const priority = (name) => name === "scroller" ? 0 : name === "renderer" ? 1 : 2;
    this.list.sort((a, b) => priority(a.name) - priority(b.name));
  }
  _tick(ts) {
    if (this._tPrev == null) {
      frameRatio = 0;
    } else {
      const delta = ts - this._tPrev;
      frameRatio = delta > 0 ? delta / FRAME_TIME : 0;
    }
    this._tPrev = ts;
    this._logFps(ts);
    const normTs = ts;
    if (this.on) {
      const len = this.list.length;
      for (let i = 0; i < len; i++) {
        const it = this.list[i];
        if (!it) continue;
        if (!it.startTime) it.startTime = normTs;
        const elapsed = normTs - it.startTime;
        try {
          it.cb(elapsed);
        } catch {
        }
      }
    }
    this._raf();
  }
  _logFps(ts) {
    const watcher = this.fpsWatcher;
    watcher.frames += 1;
    const elapsed = ts - watcher.lastTs;
    if (elapsed < 1e3) return;
    watcher.frames = 0;
    watcher.lastTs = ts;
  }
  _raf() {
    requestAnimationFrame(this._tickHandler);
  }
};
var RafHub = new _RafHub();
var Raf = class {
  constructor(name, cb, hub = RafHub) {
    this.cb = cb;
    this.hub = hub;
    this.id = null;
    this.name = name ?? "no_name";
  }
  run() {
    if (this.id) return;
    this.id = this.hub.add(this.name, this.cb);
  }
  stop() {
    if (!this.id) return;
    this.hub.remove(this.id);
    this.id = null;
  }
};
var Delay = class {
  constructor(cb, de = 0, hub = RafHub) {
    this.cb = cb;
    this.de = Math.max(0, de | 0);
    this.hub = hub;
    this.id = null;
  }
  run() {
    if (this.id) this.stop();
    const start = performance.now();
    const cb = this.cb;
    const de = this.de;
    const tick = () => {
      const now = performance.now();
      const total = now - start;
      if (total >= de) {
        this.stop();
        try {
          cb(total);
        } catch {
        }
        return;
      }
    };
    this.id = this.hub.add(`delay-${String(this.id)}`, tick);
  }
  stop() {
    if (this.id) this.hub.remove(this.id);
    this.id = null;
  }
};
var Timer = class {
  constructor({
    cb,
    de
  } = {}) {
    this._ = new Delay(cb ?? (() => {
    }), de ?? 0);
  }
  run() {
    this._.stop();
    this._.run();
  }
  stop() {
    this._.stop();
  }
};
var raf = {
  RafHub,
  Raf,
  Delay,
  Timer
};
var raf_default = raf;

export { Delay, Raf, RafHub, Timer, getFrameRatio, raf_default };
//# sourceMappingURL=chunk-WILRAE77.js.map
//# sourceMappingURL=chunk-WILRAE77.js.map